import type {PageRouteConfig} from '@router';

import NewTicket from 'modules/NewTicket/NewTicket';
import {routes} from 'routes/routes';
import {sanitizeRedirect} from 'utils/Helper';

export function createNewTicketRoute(): PageRouteConfig {
  return {
    element: <NewTicket />,
    layout: {
      title: 'ایجاد درخواست جدید',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      resolveLink: (ctx) => {
        const currentQuery = new URLSearchParams(ctx.location?.search);
        const from = currentQuery.get('from');
        const ticketsQuery = new URLSearchParams();

        for (const key of ['order_code', 'type', 'state']) {
          const value = currentQuery.get(key);
          if (value) ticketsQuery.set(key, value);
        }
        if (from) {
          ticketsQuery.set('from', sanitizeRedirect(from, routes.TICKETS));
        }

        const search = ticketsQuery.toString();
        return search ? `${routes.TICKETS}?${search}` : routes.TICKETS;
      }
    }
  };
}
